var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 79,
    viewBox: "0 0 64 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 0H5C2.23858 0 0 2.23858 0 5V73.905C0 78.3629 5.39266 80.5922 8.54046 77.4356L28.9144 57.0047C30.8903 55.0233 34.1075 55.049 36.0514 57.0617L55.4035 77.0991C58.5273 80.3335 64 78.1222 64 73.6256V5C64 2.23858 61.7614 0 59 0Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerManagementIcon);
export default __webpack_public_path__ + "static/media/BannerManagementIcon.e6634600ffeb7afc785776117ecda50e.svg";
export { ForwardRef as ReactComponent };